import * as ToggleGroupRadix from '@radix-ui/react-toggle-group'
import clsx from 'clsx'

import styles from './ToggleGroup.module.scss'

export type ToggleGroupOption<T extends string> = {
  label: React.ReactNode
  value: T
  dataTestId?: string
}

type ToggleGroupVariant = 'primary' | 'secondary'

type ToggleGroupProps<T extends string> = {
  options: ToggleGroupOption<T>[]
  value: T
  dataTestId?: string
  variant?: ToggleGroupVariant
  onChange: (value: T) => void
}

const ToggleGroup = <T extends string>(props: ToggleGroupProps<T>) => {
  const { variant = 'primary' } = props

  return (
    <ToggleGroupRadix.Root
      value={props.value}
      type="single"
      onValueChange={value => {
        if (value) props.onChange(value as T)
      }}
      className={clsx(styles.toggleGroup, styles[`${variant}Root`])}
    >
      {props.options.map(({ label, value, dataTestId }) => (
        <ToggleGroupRadix.Item
          value={value}
          key={value}
          data-test-id={dataTestId}
          className={clsx(
            value === props.value && styles.active,
            styles[variant]
          )}
        >
          {label}
        </ToggleGroupRadix.Item>
      ))}
    </ToggleGroupRadix.Root>
  )
}

export default ToggleGroup
